/**
 * SpinShot / Imajize — Shopify product media: 360 from image ALT
 *
 * Layout modes (theme classes on <product-images>):
 *
 * - Thumbnails — class product__images--thumbs: small thumb strip stays images-only;
 *   the main preview iframe loads only for the active slide (carousel / data-active-media).
 *
 * - Mobile slider — class product__images--mobile-slider on a narrow viewport: treated as
 *   inline (see below). Many themes keep --thumbs for desktop but swipe-scroll on mobile
 *   without updating data-active-media / media--active, so lazy thumbs loading would leave
 *   iframes without a src.
 *
 * - Stacked, mosaic, grid, mobile slider without thumbs — anything else (e.g.
 *   product__images--no-thumbs): each large “tile” keeps the <img> for layout but shows
 *   the 360 iframe on top. Extra URL query for those embeds is opt-in (see below).
 *
 * Usage (theme.liquid, before </body>):
 *
 *   <script>
 *     window.spinshot = window.spinshot || {};
 *
 *     // Optional — only applies to inline layouts (not thumbnail + main preview mode).
 *     // Append query string to each stacked/mosaic/grid embed URL (viewer URL API), e.g.:
 *     // window.spinshot.inline_embed_query = 'load_on=hover&manual_spin_interaction=hover';
 *     // window.spinshot.inline_embed_query = 'load_on=click';
 *
 *     // window.spinshot.force_gallery_mode = 'thumbs'; // or 'inline', if theme classes lie
 *     // window.spinshot.mobile_slider_mq = '(max-width: 749px)'; // match theme breakpoint
 *     // window.spinshot.container_path = 'product-images';
 *     // window.spinshot.preview_slides_selector = '[data-product-media-list], .product__slides';
 *   </script>
 *   <script src="{{ 'spinshot.js' | asset_url }}" defer="defer"></script>
 */
(function () {
  'use strict';

  var NS = 'spinshot';
  var CFG = (window[NS] = window[NS] || {});

  var ALT_EMBED_RE =
    /(?:https?:)?\/\/embed\.(imajize\.com|spinshot\.io)\/([^/?#\s]+)/i;

  function isProductPage() {
    if (typeof CFG.page_path_test === 'function') {
      return CFG.page_path_test(location.pathname);
    }
    return /\/products\//.test(location.pathname);
  }

  function embedRoot() {
    if (CFG.container_path) {
      var el = document.querySelector(CFG.container_path);
      if (el) return el;
    }
    return document.body;
  }

  function previewSearchRoot(root) {
    if (CFG.preview_root_selector) {
      var scoped = root.querySelector(CFG.preview_root_selector);
      if (scoped) return scoped;
    }
    return root.querySelector('product-images') || root;
  }

  function mainSlidesHost(searchRoot) {
    var sel =
      CFG.preview_slides_selector ||
      '[data-product-media-list], .product__slides, .product-single__photos';
    var parts = sel.split(/\s*,\s*/);
    for (var i = 0; i < parts.length; i++) {
      var host = searchRoot.querySelector(parts[i]);
      if (host) return host;
    }
    return null;
  }

  function isThumbnailImage(img) {
    return !!img.closest(
      'product-thumbs, .product__thumbs, .product__thumb, [data-thumb-item], [data-thumbs-slider]'
    );
  }

  function cleanupThumbnailEmbeds() {
    var thumbs = document.querySelectorAll(
      'product-thumbs .spinshot-embed, .product__thumbs .spinshot-embed'
    );
    for (var i = 0; i < thumbs.length; i++) {
      thumbs[i].remove();
    }
    var badImgs = document.querySelectorAll(
      'product-thumbs img[data-spinshot-alt-embed], .product__thumbs img[data-spinshot-alt-embed]'
    );
    for (var j = 0; j < badImgs.length; j++) {
      var im = badImgs[j];
      im.removeAttribute('data-spinshot-alt-embed');
      im.style.opacity = '';
      im.style.pointerEvents = '';
      im.removeAttribute('aria-hidden');
    }
  }

  function findProductImagesHost(el) {
    return el && el.closest && el.closest('product-images');
  }

  function isMobileSliderViewport() {
    var mq = CFG.mobile_slider_mq || '(max-width: 749px)';
    return window.matchMedia(mq).matches;
  }

  /** thumbs = separate thumb rail + main preview; inline = stacked / mosaic / grid / no-thumbs */
  function galleryLayoutMode(productImagesEl) {
    if (CFG.force_gallery_mode === 'thumbs' || CFG.force_gallery_mode === 'inline') {
      return CFG.force_gallery_mode;
    }
    if (!productImagesEl) return 'inline';
    if (
      productImagesEl.classList.contains('product__images--mobile-slider') &&
      isMobileSliderViewport()
    ) {
      return 'inline';
    }
    return productImagesEl.classList.contains('product__images--thumbs')
      ? 'thumbs'
      : 'inline';
  }

  function embedBaseUrl(storedSrc) {
    if (!storedSrc) return '';
    return storedSrc.split('?')[0].split('#')[0];
  }

  function loadIframeSrc(iframe, url) {
    if (!url) return;
    if (iframe.getAttribute('data-spinshot-loaded-src') !== url) {
      iframe.src = url;
      iframe.setAttribute('data-spinshot-loaded-src', url);
    }
  }

  function unloadIframeSrc(iframe) {
    iframe.removeAttribute('data-spinshot-loaded-src');
    if (iframe.src && iframe.src.indexOf('about:blank') !== 0) {
      iframe.src = 'about:blank';
    }
  }

  function slideIsActive(slide, activeId) {
    return (
      slide.classList.contains('media--active') ||
      (!!activeId && slide.getAttribute('data-media-id') === activeId)
    );
  }

  function withQuery(url, queryString) {
    if (queryString == null || queryString === '') return url;
    var sep = url.indexOf('?') >= 0 ? '&' : '?';
    return url + sep + queryString;
  }

  function buildEmbedSrc(baseUrl, layoutMode) {
    if (layoutMode !== 'inline') return baseUrl;
    var q = CFG.inline_embed_query;
    if (q == null || q === '') return baseUrl;
    return withQuery(baseUrl, String(q));
  }

  function findMount(img) {
    if (CFG.mountSelector) {
      var custom = img.closest(CFG.mountSelector);
      if (custom) return custom;
    }
    var figure = img.closest('figure');
    if (figure) return figure;
    return (
      img.closest(
        [
          '.product__photo',
          '.product__media-item',
          '.product__media',
          '.product-single__photo',
          '.product__modal-opener--image',
          '[data-product-single-media-group]',
          '.slider__slide',
          '.product__slide',
        ].join(', ')
      ) || img.parentElement
    );
  }

  function aspectPaddingPercent(img) {
    var w = parseInt(img.getAttribute('width'), 10);
    var h = parseInt(img.getAttribute('height'), 10);
    if (!w || !h) {
      w = img.naturalWidth || img.offsetWidth || 1;
      h = img.naturalHeight || img.offsetHeight || 1;
    }
    if (!w) w = 1;
    return (h / w) * 100;
  }

  function syncLazyEmbedsForHost(host) {
    if (!host || CFG.observe_active === false) return;
    if (galleryLayoutMode(host) !== 'thumbs') return;

    var activeId = host.getAttribute('data-active-media');
    var slides = host.querySelectorAll('.product__slide[data-media-id]');
    for (var i = 0; i < slides.length; i++) {
      var slide = slides[i];
      var iframe = slide.querySelector('.spinshot-embed iframe[data-spinshot-src]');
      if (!iframe) continue;

      var url = embedBaseUrl(iframe.getAttribute('data-spinshot-src'));
      if (!url) continue;

      if (slideIsActive(slide, activeId)) {
        loadIframeSrc(iframe, url);
      } else {
        unloadIframeSrc(iframe);
      }
    }
  }

  /** Apply or clear iframe src for embeds already in the DOM when layout mode changes. */
  function syncEmbedSourcesForLayout(host, layoutMode) {
    if (!host) return;

    if (layoutMode === 'inline') {
      var inlineIframes = host.querySelectorAll(
        '.product__slides .spinshot-embed iframe[data-spinshot-src], ' +
          '[data-product-media-list] .spinshot-embed iframe[data-spinshot-src]'
      );
      for (var i = 0; i < inlineIframes.length; i++) {
        var iframe = inlineIframes[i];
        var url = buildEmbedSrc(
          embedBaseUrl(iframe.getAttribute('data-spinshot-src')),
          'inline'
        );
        loadIframeSrc(iframe, url);
      }
      return;
    }

    syncLazyEmbedsForHost(host);
  }

  function attachPreviewEmbed(img, layoutMode) {
    if (isThumbnailImage(img)) return;
    if (img.getAttribute('data-spinshot-alt-embed') === 'done') return;

    var alt = img.getAttribute('alt') || '';
    var m = alt.match(ALT_EMBED_RE);
    if (!m) return;

    var hostPart = m[1].toLowerCase();
    var id = m[2];
    var baseSrc = 'https://embed.' + hostPart + '/' + id;
    var srcForIframe = buildEmbedSrc(baseSrc, layoutMode);

    var mount = findMount(img);
    if (mount.querySelector('.spinshot-embed')) return;

    img.setAttribute('data-spinshot-alt-embed', 'done');

    var insideFigure = mount.tagName === 'FIGURE';

    var wrap = document.createElement('div');
    wrap.className = 'spinshot-embed';

    if (insideFigure || img.parentElement === mount) {
      if (window.getComputedStyle(mount).position === 'static') {
        mount.style.position = 'relative';
      }
      wrap.style.margin = '0';
      wrap.style.padding = '0';
      wrap.style.width = '100%';
      wrap.style.height = '100%';
      wrap.style.position = 'absolute';
      wrap.style.top = '0';
      wrap.style.left = '0';
      wrap.style.right = '0';
      wrap.style.bottom = '0';
      wrap.style.zIndex = '1';
    } else {
      var pad = aspectPaddingPercent(img);
      wrap.style.margin = '0 auto';
      wrap.style.padding = pad + '% 0 0 0';
      wrap.style.width = '100%';
      wrap.style.position = 'relative';
      wrap.style.zIndex = '1';
    }

    var iframe = document.createElement('iframe');
    iframe.setAttribute(
      'data-spinshot-src',
      layoutMode === 'thumbs' ? baseSrc : srcForIframe
    );
    iframe.title =
      (CFG.iframe_title && String(CFG.iframe_title)) || '360° product view';
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('scrolling', 'no');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('allow', 'fullscreen');
    iframe.style.cssText =
      'background-color:#fff;position:absolute;top:0;left:0;width:100%;height:100%;border:0;';

    wrap.appendChild(iframe);

    img.style.opacity = '0';
    img.style.pointerEvents = 'none';
    img.setAttribute('aria-hidden', 'true');

    mount.appendChild(wrap);

    if (layoutMode === 'inline') {
      iframe.src = srcForIframe;
      iframe.setAttribute('data-spinshot-loaded-src', srcForIframe);
    }

    var savedW = parseInt(img.getAttribute('width'), 10);
    var savedH = parseInt(img.getAttribute('height'), 10);

    if ((insideFigure || img.parentElement === mount) && savedW && savedH) {
      requestAnimationFrame(function () {
        var cw = mount.offsetWidth;
        if (cw && mount.offsetHeight < 4) {
          mount.style.minHeight = Math.round((cw * savedH) / savedW) + 'px';
        }
      });
    }

    var pi = findProductImagesHost(mount);
    if (pi) syncEmbedSourcesForLayout(pi, layoutMode);
  }

  var activeSyncMo;
  var activeSyncTimer;

  function bindActiveSlideSync(slidesHost) {
    if (CFG.observe_active === false) return;
    var host = slidesHost.closest
      ? slidesHost.closest('product-images')
      : findProductImagesHost(slidesHost);
    if (!host) return;
    if (galleryLayoutMode(host) !== 'thumbs') return;
    if (host.getAttribute('data-spinshot-active-bound') === '1') return;
    host.setAttribute('data-spinshot-active-bound', '1');

    activeSyncMo = new MutationObserver(function () {
      clearTimeout(activeSyncTimer);
      activeSyncTimer = setTimeout(function () {
        syncLazyEmbedsForHost(host);
      }, CFG.active_sync_debounce_ms || 30);
    });
    activeSyncMo.observe(host, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'data-active-media'],
    });
  }

  function scan() {
    if (!isProductPage()) return;
    var root = embedRoot();
    if (!root) return;

    cleanupThumbnailEmbeds();

    var searchRoot = previewSearchRoot(root);
    var slidesHost = mainSlidesHost(searchRoot);
    if (!slidesHost) return;

    var pi = findProductImagesHost(slidesHost);
    var layoutMode = galleryLayoutMode(pi);

    bindActiveSlideSync(slidesHost);

    var candidates = slidesHost.querySelectorAll(
      'img[alt*="embed.imajize.com"], img[alt*="embed.spinshot.io"]'
    );
    for (var i = 0; i < candidates.length; i++) {
      attachPreviewEmbed(candidates[i], layoutMode);
    }

    if (pi) syncEmbedSourcesForLayout(pi, layoutMode);
  }

  function bindLayoutModeListener() {
    if (CFG.observe_resize === false) return;
    var mq = window.matchMedia(CFG.mobile_slider_mq || '(max-width: 749px)');
    var resizeTimer;
    var onLayoutChange = function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(scan, CFG.resize_debounce_ms || 100);
    };
    if (mq.addEventListener) {
      mq.addEventListener('change', onLayoutChange);
    } else if (mq.addListener) {
      mq.addListener(onLayoutChange);
    }
  }

  function init() {
    scan();
    bindLayoutModeListener();
    if (CFG.observe !== false && typeof MutationObserver !== 'undefined') {
      var t;
      var mo = new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(scan, CFG.observe_debounce_ms || 150);
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  window.spinshotScanAltEmbeds = scan;
  window.spinshotSyncActiveEmbeds = function (host) {
    syncLazyEmbedsForHost(host || document.querySelector('product-images'));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
